import "VSS/LoaderPlugins/Css!Agile/Scripts/Backlog/ContextMenu/Components/ChangeParentDialog";

import React = require("react");
import * as Utils_String from "VSS/Utils/String";
import { ITeam, TeamBuilder } from "Agile/Scripts/Models/Team";
import * as BacklogContentViewResources from "Agile/Scripts/Resources/TFS.Resources.BacklogsHub.BacklogView";
import { VssIconType } from "VSSUI/VssIcon";
import { Callout, DirectionalHint } from "OfficeFabric/Callout";
import { IPickListItem, IPickListSelection, PickList } from "VSSUI/PickList";
import { getClient as getCoreClient } from "TFS/Core/RestClient";
import { WebApiTeam } from "TFS/Core/Contracts";
import { batchGet } from "Presentation/Scripts/TFS/TFS.Rest.Utils";
import { LoadingComponent } from "Presentation/Scripts/TFS/Components/LoadingComponent";
import { format } from "VSS/Utils/String";
import * as AgileProductBacklogResources from "Agile/Scripts/Resources/TFS.Resources.AgileProductBacklog";

export interface ITeamPickerCalloutProps {
    projectId: string;
    calloutTargetQuerySelector: string;
    selectedTeam?: ITeam;
    onDismiss: () => void;
    onSelection: (team: ITeam) => void;
}

export const TeamPickerCallout = (props: ITeamPickerCalloutProps) => {
    const [teams, setTeams] = React.useState(undefined as ITeam[] | undefined);
    const [errorMessage, setErrorMessage] = React.useState(undefined as string);

    React.useEffect(() => {
        (async () => {
            try {
                const restClient = getCoreClient();
                const getTeams = (top: number, skip: number) => restClient.getTeams(props.projectId, false, top, skip);
                const webApiTeams: WebApiTeam[] = await batchGet(getTeams);
                const sortedTeams = webApiTeams
                    .map(teamResource => TeamBuilder.fromWebApiTeam(teamResource))
                    .sort((a, b) => Utils_String.localeIgnoreCaseComparer(a.name, b.name));
                setTeams(sortedTeams);
            } catch (error) {
                setErrorMessage(format(AgileProductBacklogResources.ChangeParentErrorLoadingTeamsMessage, error.message));
            }
        })();
    }, []);

    let _pickListRef: PickList | undefined;

    const render = () => {
        const { calloutTargetQuerySelector, onDismiss } = props;

        return (
            <Callout
                target={calloutTargetQuerySelector}
                onDismiss={onDismiss}
                directionalHint={DirectionalHint.bottomLeftEdge}
                isBeakVisible={false}
                setInitialFocus={true}
                onPositioned={_onCalloutPositioned}
            >
                {_renderContent()}
            </Callout>
        );
    };

    const _renderContent = (): JSX.Element => {
        const { selectedTeam } = props;

        if (errorMessage) {
            return <p>{errorMessage}</p>;
        } else if (teams) {
            return (
                <PickList
                    className="change-parent-dialog-team-callout"
                    ref={_resolvePickListRef}
                    isSearchable={true}
                    items={teams}
                    getListItem={_getPickListItem}
                    selectedItems={[selectedTeam]}
                    onSelectionChanged={_onTeamSelected}
                    searchTextPlaceholder={BacklogContentViewResources.MappingPane_TeamSearchPlaceholder}
                />
            );
        }
        return <LoadingComponent />;
    };

    const _getPickListItem = (team: ITeam): IPickListItem => {
        return {
            key: team.id,
            name: team.name,
            iconProps: { iconType: VssIconType.fabric, iconName: "People" }
        };
    };

    const _onTeamSelected = (selection: IPickListSelection): void => {
        const team: ITeam = selection.selectedItems[0];
        props.onSelection(team);
    };

    const _resolvePickListRef = (element: PickList): void => {
        _pickListRef = element;
    };

    const _onCalloutPositioned = (): void => {
        if (_pickListRef) {
            _pickListRef.focus();
        }
    };

    return render();
};
